import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {BsDropdownModule, BsDropdownDirective} from "ngx-bootstrap/dropdown";
import {addClass, removeClass} from "@wm/core";

const POSITION = {
  DOWN_RIGHT: 'down,right',
  DOWN_LEFT: 'down,left',
  UP_RIGHT: 'up,right',
  UP_LEFT: 'up,left',
  INLINE: 'inline'
};
const CARET_CLS = {
  UP: 'fa-caret-up',
  DOWN: 'fa-caret-down'
};
const PULL_CLS = {
  LEFT: 'pull-left',
  RIGHT: 'pull-right'
};
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-menu',
  hostClass: 'dropdown app-menu',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmMenu]',
  template: `
    <ng-template #menuTemplate>
      <div dropdown>
        <button dropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
                [attr.aria-label]="hint || 'Menu'"
                class="btn app-button dropdown-toggle {{menuclass}}"
                hint.bind="hint"
                shortcutkey.bind="shortcutkey"
                tabindex.bind="tabindex"
                caption.bind="caption"
                iconclass.bind="iconclass"
                [ngStyle]="{width: menuButtonWidth}"
                iconposition.bind="iconposition">
          <i class="app-icon {{iconclass}}"></i>
          <span class="caption" [textContent]="caption"></span>
          <span class="pull-right caret fa {{menuCaret}}"></span></button>
      </div>
    </ng-template>
    <ng-container *ngIf="type === 'anchor'; else menuTemplate">
        <a
           href="javascript:void(0);"
           role="button"
           aria-haspopup="true"
           aria-expanded="false"
           hint.bind="hint"
           class=" app-anchor dropdown-toggle {{menuclass}}"
           shortcutkey.bind="shortcutkey"
           tabindex.bind="tabindex"
           caption.bind="caption"
           iconclass.bind="iconclass"
           iconposition.bind="iconposition"
           badgevalue.bind="badgevalue">
          <i class="app-icon {{iconclass}}"></i>
          <span class="caption" [textContent]="caption"></span>
          <span class="pull-right caret fa {{menuCaret}}"></span>
        </a>
    </ng-container>
  `,
  providers: [
    provideAsWidgetRef(MenuComponent)
  ],
  exportAs: 'wmMenu',
  standalone: true,
  imports: [CommonModule, BsDropdownModule],
  styles: []
})
export class MenuComponent extends StylableComponent {
  static initializeProps = register('wm-menu');

  public menualign: string;
  public menuposition: string;
  public menulayout: string;
  public menuclass: string;
  public linktarget: string;
  public iconclass: string;
  public animateitems: string;
  public disableMenuContext: boolean;
  public autoclose: string;
  public autoopen: string;
  public hint: string;
  public caption: string;
  public menuButtonWidth:string;

  public menuCaret = 'fa-caret-down';

  public type: any;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === "width") {
        this.menuButtonWidth = nv;
      }
    });
  }

  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('button.dropdown-toggle') || this.nativeElement;
  }

  override onPropertyChange(key: string, nv: any, ov?: any) {

    if (key === 'tabindex') {
      return;
    }
    if (key === 'menuposition') {
      switch (nv) {
        case POSITION.DOWN_RIGHT:
          removeClass(this.nativeElement, 'dropup');
          this.menualign = PULL_CLS.LEFT;
          this.menuCaret = CARET_CLS.DOWN;
          break;
        case POSITION.DOWN_LEFT:
          removeClass(this.nativeElement, 'dropup');
          this.menualign = PULL_CLS.RIGHT;
          this.menuCaret = CARET_CLS.DOWN;
          break;
        case POSITION.UP_LEFT:
          addClass(this.nativeElement, 'dropup');
          this.menualign = PULL_CLS.RIGHT;
          this.menuCaret = CARET_CLS.UP;
          break;
        case POSITION.UP_RIGHT:
          addClass(this.nativeElement, 'dropup');
          this.menualign = PULL_CLS.LEFT;
          this.menuCaret = CARET_CLS.UP;
          break;
        case POSITION.INLINE:
          this.menualign = 'dropinline-menu';
          break;
      }
    }
    super.onPropertyChange(key, nv, ov);
  }

}

